import * as R from 'ramda';
// helpers/constants
import * as G from '../../../../helpers';
import * as GC from '../../../../constants';
import {
  ITEM_DIMENSIONS_OPTIONS,
  ACCESSORIAL_TYPE_OPTIONS,
  ACCESSORIAL_MATRIX_TYPE_OPTIONS,
  getSharedAccessorialAutoApplyToTypeOptions,
  DEFAULT_DRIVER_ASSESSORIAL_RATE_TYPE_OPTIONS,
  DEFAULT_ACCESSORIAL_FORM_RATE_UNIT_GROUP_OPTIONS,
} from '../../../../helpers/options';
// forms
import { districtOptions, timePeriodOptions } from '../../../../forms/forms/accessorial-form/field-settings';
//////////////////////////////////////////////////

const rateUnitOptions = R.compose(
  R.filter(({ value }) => G.isNotEmpty(value)),
  R.uniqBy(R.prop(GC.FIELD_VALUE)),
  R.flatten,
  R.values,
)(DEFAULT_ACCESSORIAL_FORM_RATE_UNIT_GROUP_OPTIONS);

const rateUnitOptionsMap = R.indexBy(R.prop(GC.FIELD_VALUE), rateUnitOptions);

const getOptionLabel = (value, options) => R.compose(
  R.propOr(value, GC.FIELD_LABEL),
  R.find(R.propEq(value, GC.FIELD_VALUE)),
)(options);

export const sharedAccessorialSettings = {
  [GC.FIELD_NAME]: {
    name: 'titles:name',
  },
  [GC.FIELD_TYPES]: {
    fieldType: 'enum',
    collection: true,
    name: 'titles:types',
    filterType: 'selectMultiple',
    options: ACCESSORIAL_TYPE_OPTIONS,
  },
  [GC.FIELD_CREATED_BY]: {
    name: 'titles:created-by',
  },
  // TODO: uncomment when be will be done
  // [GC.FIELD_ACCESSORIAL_ACCESSORIAL_GUID]: {
  //   width: 200,
  //   searchable: true,
  //   name: 'titles:accessorial',
  //   customComponent: R.path(['data', GC.FIELD_DISPLAYED_VALUE]),
  // },
  // [GC.FIELD_NON_TAXABLE]: {
  //   width: 150,
  //   type: 'boolean',
  //   searchable: true,
  //   filterType: 'boolean',
  //   name: 'titles:non-taxable',
  // },
  // [GC.FIELD_FUEL_RELATED]: {
  //   width: 100,
  //   type: 'boolean',
  //   filterType: 'boolean',
  //   name: 'titles:fuel-related',
  // },
  [GC.FIELD_CHARGE_RATE]: {
    name: 'titles:rate',
    filterType: 'number',
  },
  [GC.FIELD_CURRENCY]: {
    name: 'titles:currency',
    options: GC.CURRENCY_OPTIONS,
    filterType: 'selectMultiple',
  },
  [GC.FIELD_CHARGE_RATE_TYPE]: {
    fieldType: 'enumLocale',
    name: 'titles:rate-type',
    filterType: 'selectMultiple',
    options: R.drop(1, DEFAULT_DRIVER_ASSESSORIAL_RATE_TYPE_OPTIONS),
  },
  [GC.FIELD_CHARGE_RATE_UNIT]: {
    name: 'titles:rate-unit',
    options: rateUnitOptions,
    filterType: 'selectMultiple',
    customComponent: ({ data: { rateUnit } }) => {
      if (G.isNilOrEmpty(rateUnit)) return null;

      return R.pathOr(rateUnit, [rateUnit, GC.FIELD_LABEL], rateUnitOptionsMap);
    },
  },
  [GC.FIELD_CHARGE_MIN_RATE]: {
    filterType: 'number',
    name: 'titles:rate-minimum',
  },
  [GC.FIELD_CHARGE_MAX_RATE]: {
    filterType: 'number',
    name: 'titles:rate-maximum',
  },
  [GC.FIELD_MIN_STOPS]: {
    filterType: 'number',
    name: 'titles:min-stops',
  },
  [GC.FIELD_MAX_STOPS]: {
    filterType: 'number',
    name: 'titles:max-stops',
  },
  [GC.FIELD_ACCESSORIAL_DISTRICT]: {
    name: 'titles:district',
    options: districtOptions,
    filterType: 'selectMultiple',
    customComponent: ({ data }) => R.pathOr(
      R.prop(GC.FIELD_ACCESSORIAL_DISTRICT, data),
      [R.prop(GC.FIELD_ACCESSORIAL_DISTRICT, data)],
      GC.districtMap,
    ),
  },
  [GC.FIELD_TIME_PERIOD]: {
    fieldType: 'enumLocale',
    name: 'titles:time-period',
    options: timePeriodOptions,
    filterType: 'selectMultiple',
  },
  [GC.FIELD_AUTO_APPLY_TO]: {
    collection: true,
    name: 'titles:auto-apply-to',
    filterType: 'selectMultiple',
    options: getSharedAccessorialAutoApplyToTypeOptions(),
    customComponent: ({ data }) => R.compose(
      R.join(', '),
      R.map((item) => R.compose(
        R.path([GC.FIELD_LABEL]),
        R.find(R.propEq(item, GC.FIELD_VALUE)),
      )(getSharedAccessorialAutoApplyToTypeOptions())),
      R.pathOr([], [GC.FIELD_AUTO_APPLY_TO]),
    )(data),
  },
  [GC.FIELD_ACCESSORIAL_USE_FUEL_INDEX]: {
    fieldType: 'boolean',
    filterType: 'boolean',
    name: 'titles:use-fuel-index',
  },
  [GC.FIELD_ACCESSORIAL_MATRIX_TYPE]: {
    name: 'titles:matrix-type',
    filterType: 'selectMultiple',
    customComponent: ({ data }) => getOptionLabel(
      R.prop(GC.FIELD_ACCESSORIAL_MATRIX_TYPE, data),
      ACCESSORIAL_MATRIX_TYPE_OPTIONS,
    ),
    options: R.tail(ACCESSORIAL_MATRIX_TYPE_OPTIONS),
  },
  [GC.FIELD_ACCESSORIAL_MATRIX_UOM]: {
    name: 'titles:matrix-uom',
    filterType: 'selectMultiple',
    options: R.tail(ITEM_DIMENSIONS_OPTIONS),
    customComponent: ({ data }) => getOptionLabel(
      R.prop(GC.FIELD_ACCESSORIAL_MATRIX_UOM, data),
      ITEM_DIMENSIONS_OPTIONS,
    ),
  },
  [GC.FIELD_ACCESSORIAL_MATRIX_VARIABLES]: {
    collection: true,
    searchable: false,
    disableFilter: true,
    name: 'titles:matrix-variables',
    customComponent: R.compose(
      R.length,
      R.pathOr([], ['data', GC.FIELD_ACCESSORIAL_MATRIX_VARIABLES]),
    ),
  },
  [GC.FIELD_DEDUCTION]: {
    fieldType: 'boolean',
    filterType: 'boolean',
    name: 'titles:deduction',
  },
  [GC.FIELD_BRANCH_DOT_BRANCH_NAME]: {
    name: 'titles:branch',
  },
  [GC.GRC.MODE_DISPLAYED_VALUE]: {
    name: 'titles:mode',
  },
  ...G.getAddressPointFieldsByType(GC.FIELD_ORIGIN),
  ...G.getAddressPointFieldsByType(GC.FIELD_DESTINATION),
};
